import { txt } from './i18n/i18n';

export function getOptions() {
    return [
        { name: txt('Custom'), value: 'Custom' },
        { name: txt('Numbers'), value: 'Numbers' },
        { name: txt('Frequency'), value: 'Frequency' },
        { name: txt('Quality'), value: 'Quality' },
        { name: txt('Agreement'), value: 'Agreement' },
        { name: txt('Importance'), value: 'Importance' },
        { name: txt('Satisfaction'), value: 'Satisfaction' },
        { name: txt('Emojis'), value: 'Emoji' },
    ].sort(compareFn);
}

function compareFn(a, b) {
    if (a.value === 'Custom' || b.value === 'Custom') {
        return 1;
    }

    if (a.name < b.name) {
        return -1;
    }

    if (a.name > b.name) {
        return 1;
    }

    return 0;
}

export function getAlternativeText(index, type) {
    switch (type) {
        case 'Numbers':
            if (index === 0) {
                return '1';
            }

            if (index === 1) {
                return '2';
            }

            if (index === 2) {
                return '3';
            }

            if (index === 3) {
                return '4';
            }

            if (index === 4) {
                return '5';
            }

            break;
        case 'Frequency':
            if (index === 0) {
                return txt('Frequency_Never');
            }

            if (index === 1) {
                return txt('Frequency_Rarely');
            }

            if (index === 2) {
                return txt('Frequency_Sometimes');
            }

            if (index === 3) {
                return txt('Frequency_Often');
            }

            if (index === 4) {
                return txt('Frequency_Always');
            }

            break;
        case 'Quality':
            if (index === 0) {
                return txt('Quality_Very_Poor');
            }

            if (index === 1) {
                return txt('Quality_Poor');
            }

            if (index === 2) {
                return txt('Quality_Fair');
            }

            if (index === 3) {
                return txt('Quality_Good');
            }

            if (index === 4) {
                return txt('Quality_Excellent');
            }

            break;
        case 'Agreement':
            if (index === 0) {
                return txt('Agreement_Strongly_Disagree');
            }

            if (index === 1) {
                return txt('Agreement_Disagree');
            }

            if (index === 2) {
                return txt('Agreement_Neither_Agree_Nor_Disagree');
            }

            if (index === 3) {
                return txt('Agreement_Agree');
            }

            if (index === 4) {
                return txt('Agreement_Strongly_Agree');
            }

            break;
        case 'Importance':
            if (index === 0) {
                return txt('Importance_Not_At_All_Important');
            }

            if (index === 1) {
                return txt('Importance_Slightly_Important');
            }

            if (index === 2) {
                return txt('Importance_Moderately_Important');
            }

            if (index === 3) {
                return txt('Importance_Very_Important');
            }

            if (index === 4) {
                return txt('Importance_Extremely_Important');
            }

            break;
        case 'Satisfaction':
            if (index === 0) {
                return txt('Satisfaction_Not_At_All_Satisfied');
            }

            if (index === 1) {
                return txt('Satisfaction_Slightly_Satisfied');
            }

            if (index === 2) {
                return txt('Satisfaction_Moderately_Satisfied');
            }

            if (index === 3) {
                return txt('Satisfaction_Very_Satisfied');
            }

            if (index === 4) {
                return txt('Satisfaction_Completely_Satisfied');
            }

            break;
        case 'Emoji':
            if (index === 0) {
                return '🙁';
            }

            if (index === 1) {
                return '😐';
            }

            if (index === 2) {
                return '🙂';
            }

            if (index === 3) {
                return '';
            }

            if (index === 4) {
                return '';
            }

            break;
    }

    return '';
}
